import { useState, useEffect } from "react";
import type { Diary, DbDiary } from "../types/diary";
import type { RealtimePostgresChangesPayload } from "@supabase/supabase-js";
import { diaryService, convertToAppDiary } from "../services/diaryService";

export const useDiaries = () => {
	const [diaries, setDiaries] = useState<Diary[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		const fetchDiaries = async () => {
			try {
				const data = await diaryService.getDiaries();
				setDiaries(data);
			} catch (err) {
				setError(err as Error);
			} finally {
				setLoading(false);
			}
		};

		fetchDiaries();

		// リアルタイム更新のサブスクリプション
		const subscription = diaryService.subscribeToChanges(
			(payload: RealtimePostgresChangesPayload<DbDiary>) => {
				if (payload.eventType === "INSERT") {
					setDiaries((prev) => [convertToAppDiary(payload.new), ...prev]);
				} else if (payload.eventType === "UPDATE") {
					setDiaries((prev) =>
						prev.map((diary) =>
							diary.id === payload.new.id
								? convertToAppDiary(payload.new)
								: diary,
						),
					);
				} else if (payload.eventType === "DELETE") {
					setDiaries((prev) =>
						prev.filter((diary) => diary.id !== payload.old.id),
					);
				}
			},
		);

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	return {
		diaries,
		loading,
		error,
		createDiary: diaryService.createDiary,
		updateDiary: diaryService.updateDiary,
		deleteDiary: diaryService.deleteDiary,
	};
};
